
.progress {
  width: 60%;
  height: 60%;
  position: absolute;
  top: 20%;
  left: 20%;

}

.thumbnail {
  position: relative;

  border-radius: var(--border-radius);

  &.dragging {
    cursor: grabbing !important;
  }

  .image {

    width: 100%;
    height: 100%;
    object-fit: contain;
    //transition: scale 1s ease, transform 1s ease;
  }

  .toolbar {
    display: none;
    gap: 0.25em;
    position: absolute;
    right: 0.5em;
    top: 0.5em;
    opacity: 0.8;
    justify-content: center;
    align-items: center;

    button {
      padding: 0.5rem .75rem;
      outline: 1px solid white;

      &:hover {
        background-color: var(--beigedark);
      }

      &.delete {
      }

      &.move {
        cursor: grab;
      }
    }
  }

  &:hover .toolbar {
    display: flex
  }
}

